import { Grid, Box, Stack } from "@mui/material";
import { useState } from "react";
import DeletePoDialog from "./DeletePoDialog";
import CreateBreakdownDialog from "./CreateBreakdownDialog";
import CalculateNetSalesDialog from "./CalculateNetSalesDialog";
import CreateSkusAndPoDialog from "./CreateSkusAndPoDialog";
import UndoDialog from "./UndoStatusDialog";
import { STATUSES } from "../utils/constants";
import RequestApprovalDialog from '../components/RequestApprovalDialog';
import ApprovePoDialog from "./ApprovePoDialog";
import ConfirmVendorDialog from "./ConfirmVendorDialog";
import AddTrackingDialog from "./AddTrackingDialog";
import MarkDeliveredDialog from "./MarkDeliveredDialog";
import MarkReceivedDialog from "./MarkReceivedDialog";
import ApproveResolutionDialog from "./ApproveResolutionDialog";
import UnarchivePoDialog from "./UnarchivePoDialog";

export default function ActionRowButtons({ row, addSnackbar, fetchPos }) {
  const [buttonLoading, setButtonLoading] = useState(false);

  let undoAction = 'Undo ';
  if (row.status === STATUSES.projectionsCreated || row.status === STATUSES.userErrorNet) {
    undoAction += 'Projections';
  } else {
    undoAction += 'Net Sales';
  }

  return (
    <Grid container alignItems="center" wrap="nowrap">
      <Grid item sx={{ minWidth: 60 }}>
        {row.actions.includes("undo_status") && (
          <Box>
            <UndoDialog
              buttonLoading={buttonLoading}
              setButtonLoading={setButtonLoading}
              po_doc_id={row.doc_id}
              poName={row.name}
              status={row.status}
              addSnackbar={addSnackbar}
              fetchPos={fetchPos}
              undoAction={undoAction}
            />
          </Box>
        )}
      </Grid>

      <Grid item xs sx={{ minWidth: 60 }}>
        <Stack direction="row" spacing={1} justifyContent="center">
          {row.actions.includes("create_breakdown") && (
            <Box>
              <CreateBreakdownDialog
                buttonLoading={buttonLoading}
                setButtonLoading={setButtonLoading}
                po_doc_id={row.doc_id}
                poName={row.name}
                addSnackbar={addSnackbar}
                fetchPos={fetchPos}
                isIcon={true}
              />
            </Box>
          )}
          {row.actions.includes("calculate_net_sales") && (
            <Box>
              <CalculateNetSalesDialog
                po_doc_id={row.doc_id}
                poName={row.name}
                addSnackbar={addSnackbar}
                fetchPos={fetchPos}
                isIcon={true}
              />
            </Box>
          )}
          {row.actions.includes("create_skus_and_po") && (
            <Box>
              <CreateSkusAndPoDialog
                buttonLoading={buttonLoading}
                setButtonLoading={setButtonLoading}
                po_doc_id={row.doc_id}
                poName={row.name}
                type={row.type}
                addSnackbar={addSnackbar}
                fetchPos={fetchPos}
                currentPoId={row.po_id ? row.po_id : ''}
                isIcon={true}
                upcGenerationAllowed={row.upc_generation_allowed}
                upcGenerationRequested={row.upc_generation_requested}
              />
            </Box>
          )}
          {row.actions.includes("request_approval") && (
            <Box>
              <RequestApprovalDialog
                po_doc_id={row.doc_id}
                poName={row.name}
                addSnackbar={addSnackbar}
                isIcon={true}
                fetchPos={fetchPos}
              />
            </Box>
          )}
          {row.actions.includes("approve_po") && (
            <Box>
              <ApprovePoDialog
                po_doc_id={row.doc_id}
                poName={row.name}
                addSnackbar={addSnackbar}
                isIcon={true}
                fetchPos={fetchPos}
              />
            </Box>
          )}
          {row.actions.includes("confirm_vendor") && (
            <Box>
              <ConfirmVendorDialog
                po_doc_id={row.doc_id}
                poName={row.name}
                addSnackbar={addSnackbar}
                isIcon={true}
                fetchPos={fetchPos}
              />
            </Box>
          )}
          {row.actions.includes("add_tracking") && (
            <Box>
              <AddTrackingDialog
                po_doc_id={row.doc_id}
                poName={row.name}
                addSnackbar={addSnackbar}
                isIcon={true}
                fetchPos={fetchPos}
              />
            </Box>
          )}
          {row.actions.includes("add_delivery") && (
            <Box>
              <MarkDeliveredDialog
                po_doc_id={row.doc_id}
                poName={row.name}
                addSnackbar={addSnackbar}
                isIcon={true}
                fetchPos={fetchPos}
              />
            </Box>
          )}
          {row.actions.includes("mark_received") && (
            <Box>
              <MarkReceivedDialog
                po_doc_id={row.doc_id}
                poName={row.name}
                addSnackbar={addSnackbar}
                isIcon={true}
                fetchPos={fetchPos}
              />
            </Box>
          )}
          {row.actions.includes("approve_resolution") && (
            <Box>
              <ApproveResolutionDialog
                po_doc_id={row.doc_id}
                poName={row.name}
                addSnackbar={addSnackbar}
                isIcon={true}
                fetchPos={fetchPos}
              />
            </Box>
          )}
          {row.actions.includes("unarchive_po") && (
            <Box>
              <UnarchivePoDialog
                po_doc_id={row.doc_id}
                poName={row.name}
                addSnackbar={addSnackbar}
                fetchPos={fetchPos}
              />
            </Box>
          )}
        </Stack>
      </Grid>

      <Grid item sx={{ minWidth: 60 }}>
        {row.actions.includes("delete_po") && (
          <Box>
            <DeletePoDialog
              isApproved={true}
              buttonLoading={buttonLoading}
              setButtonLoading={setButtonLoading}
              po_doc_id={row.doc_id}
              poName={row.name}
              addSnackbar={addSnackbar}
              fetchPos={fetchPos}
              scPoId={row.po_id}
              isIcon={true}
            />
          </Box>
        )}
        {row.actions.includes("delete_po_draft") && (
          <Box>
            <DeletePoDialog
              isApproved={false}
              buttonLoading={buttonLoading}
              setButtonLoading={setButtonLoading}
              po_doc_id={row.doc_id}
              poName={row.name}
              addSnackbar={addSnackbar}
              fetchPos={fetchPos}
              scPoId={row.po_id}
              isIcon={true}
            />
          </Box>
        )}
      </Grid>
    </Grid>
  );
}